<template>
	<AssessmentCharacteristics class="collaboration-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `handshake-simple` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.CollaborationCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";
export default {
	name: "CollaborationCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	computed: {
		characteristics() {
			return this.assessment?.teamingContent?.effectiveCollaborationGuidance || [];
		},
	},
};
</script>

<style lang="scss" scoped></style>
